export type User = {
  roles?: string[];
  shops?: number[];
};

export const hasRight = (user: User = {}, right: string = ''): boolean => {
  return user.roles?.includes(right) ?? false;
};
